
var id = "close";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 199.98 66.3\" id=\"close\"><defs><style>#close .cls-1{fill:#a0a3b8;}</style></defs><title>收起icon</title><path class=\"cls-1\" d=\"M100,66.9a21.66,21.66,0,0,1,10.2,2.5l84,43.6a10.69,10.69,0,0,1-9.8,19l-84-43.6a1.1,1.1,0,0,0-.8,0L15.6,132a10.69,10.69,0,0,1-9.8-19l84-43.6A21.66,21.66,0,0,1,100,66.9Z\" transform=\"translate(0 -66.9)\" /></symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
